import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M15 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0m2.853 10.119.042.252a.99.99 0 0 1-.427.984 9.86 9.86 0 0 1-10.922.01.98.98 0 0 1-.42-1.009l.057-.284a5.66 5.66 0 0 1 2.052-3.355 5.66 5.66 0 0 1 3.508-1.217h.658a5.53 5.53 0 0 1 5.452 4.619m1.973-.329a7.5 7.5 0 0 0-2.285-4.262q.226-.028.459-.028a3.74 3.74 0 0 1 3.65 2.929l.117.523a1.1 1.1 0 0 1-.808 1.308l-.08.02q-.484.12-.97.2a3 3 0 0 0-.041-.438zM7 7q.001-.479.086-.93a2.5 2.5 0 1 0 1.153 4.226A4.98 4.98 0 0 1 7 7m-2.78 9.686A7.65 7.65 0 0 1 6.078 13H6c-1.763 0-3.3 1.2-3.728 2.91l-.03.12a1 1 0 0 0 .728 1.212l.173.044q.48.12.966.199.005-.258.056-.515zm11.54-6.39A4.98 4.98 0 0 0 17 7q0-.479-.087-.93.284-.07.587-.07a2.5 2.5 0 1 1-1.74 4.296"
    }
  )
);
var SvgConferenceFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ConferenceFilled_default = SvgConferenceFilled;

export { ConferenceFilled_default as default };
